module.exports = __webpack_public_path__ + "media/basic-details/meetup@1x-857ba5d4.png";